import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core';
//Icones
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
//Componentes
import VitalizePaper from '../VitalizePaper';
import QuestaoObrigatoria from './QuestaoObrigatoria';
import QuestaoEscolha from './QuestaoEscolha';
import QuestaoGrafico from './QuestaoGrafico';
import QuestaoLimite from './QuestaoLimite';
import QuestaoConteudo from './QuestaoConteudo';
import ConfirmDialog from '../ConfirmDialog';
//Modelos
import QuestionarioQuestao, { TIPO_ESCOLHA, TIPO_FOTO, TIPO_INTEIRO, TIPO_MULTIPLAESCOLHA, TIPO_NUMERICO, TIPO_TEXTO, TIPO_TEXTO_FIXO } from '../../models/QuestionarioQuestao';
import ErroQuestionarioQuestao from '../../models/ErroQuestionarioQuestao';

const styles = (theme) => ({
    questao: {
        marginTop: theme.spacing(1)
    }
});

const tipos = [
    { id: TIPO_TEXTO           , descricao: 'Texto'            , classes: [ QuestaoObrigatoria ] },
    { id: TIPO_INTEIRO         , descricao: 'Inteiro'          , classes: [ QuestaoObrigatoria, QuestaoGrafico, QuestaoLimite ] },
    { id: TIPO_NUMERICO        , descricao: 'Numérico'         , classes: [ QuestaoObrigatoria, QuestaoGrafico, QuestaoLimite ] },
    { id: TIPO_ESCOLHA         , descricao: 'Escolha'          , classes: [ QuestaoObrigatoria, QuestaoGrafico, QuestaoEscolha ] },
    { id: TIPO_MULTIPLAESCOLHA , descricao: 'Multipla escolha' , classes: [ QuestaoObrigatoria, QuestaoEscolha ] },
    { id: TIPO_FOTO            , descricao: 'Foto'             , classes: [ QuestaoObrigatoria ] },
    { id: TIPO_TEXTO_FIXO      , descricao: 'Texto fixo'       , classes: [ QuestaoConteudo ] }
];

/**
 * Componente para configurar uma questão do questionário
 */
class Questao extends React.Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleUpClick = this.handleUpClick.bind(this);
        this.handleDownClick = this.handleDownClick.bind(this);
        this.handleQuestaoCorpoChange = this.handleQuestaoCorpoChange.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        //Estado inicial
        this.state = {
            confirmarExclusao: false
        };
    }

    /**
     * Trata a alteração nos campos do componente
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Copia o valor recebido
        const questao = QuestionarioQuestao.clone(this.props.questao);
        //Atualiza o título
        questao[event.target.name] = event.target.value;
        //Dispara o evento
        this.dispararEventoChange(questao);
    }

    /**
     * Trata as alterações nos checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Copia o valor recebido
        const questao = QuestionarioQuestao.clone(this.props.questao);
        //Atualiza somente o valor do campo alterado
        questao[event.target.name] = event.target.checked;
        //Atualiza o estado
        this.dispararEventoChange(questao);
    }

    /**
     * Trata o click do botão de exclusão
     */
    handleDeleteClick() {
        const possuiOpcaoResposta = (this.props.questao.tipo === TIPO_ESCOLHA || this.props.questao.tipo === TIPO_MULTIPLAESCOLHA) 
                                    && this.props.questao.opcoes.length > 0;
        const possuiAlteracao = !!this.props.questao.titulo;
        //Caso exista uma alteração
        if (possuiAlteracao || possuiOpcaoResposta) {
            //Exibe o dialog para o usuário
            this.setState({ confirmarExclusao: true });
        } else {
            //Dipara o evento para os componentes superiores
            this.dispararEventoDelete(this.props.questao);
        }
    }

    /**
     * Trata o click do botão para movimentar para cima
     */
    handleUpClick() {
        //Verifica se o evento está definido
        if (this.props.onMoveUp)
            this.props.onMoveUp(this.props.questao);
    }

    /**
     * Trata o click do botão para movimentar para baixo
     */
    handleDownClick() {
        //Verifica se o evento está definido
        if (this.props.onMoveDown)
            this.props.onMoveDown(this.props.questao);
    }

    /**
     * Trata a alteração no conteúdo da questão
     * @param {QuestionarioQuestao} questao Objeto com os dados da questão atualizados
     */
    handleQuestaoCorpoChange(questao) {
        //Dispara o evento de alteração
        this.dispararEventoChange(questao);
    }

    /**
     * Trata a escolha do usuário no dialog de confirmação
     * @param {Boolean} confirmacao Indica se o usuário confirmou a exclusão
     */
    handleDialogClose(confirmacao) {
        if (confirmacao) {
            //Dispara o evento de exclusão
            this.dispararEventoDelete(this.props.questao);
        } else {
            //Fecha o dialog
            this.setState({ confirmarExclusao: false });
        }
    }

    /**
     * Dispara o evento sinalizando que houve alteração nos valores
     * @param {QuestionarioQuestao} value Objeto com valores atualizados
     */
    dispararEventoChange(value) {
        //Verifica se não é somente leitura e se o evento está definido
        if (!this.props.readOnly && this.props.onChange)
            //Invoca com o novo valor
            this.props.onChange(value);
    }

    /**
     * Dispara o evento sinalizando que a questão deve ser excluída
     * @param {QuestionarioQuestao} questao Objeto com a questão excluída
     */
    dispararEventoDelete(questao) {
        //Verifica se o evento está definido
        if (this.props.onDelete)
            //Invoca com a questão
            this.props.onDelete(questao);
    }

    /**
     * Renderiza o corpo da questão de acordo com o tipo definido
     * @param {ErroQuestionarioQuestao} erros Mensagens de erro da questão
     * @returns {React.Component|undefined} Retorna o componente correspondente
     */
    renderizarCorpo(erros) {
        const { questao } = this.props;
        //Verifica se o tipo está definido
        if (questao.tipo)
        {
            //Busca o tipo na lista
            const tipo = tipos.find(t => t.id === questao.tipo);
            //Verifica se o tipo existe e se possui uma classe de componente
            if (tipo && tipo.classes) {
                //Renderiza os componentes
                return tipo.classes.map(classe => React.createElement(classe, { questao: questao, erros, focoAutomatico: this.props.focoAutomatico, readOnly: this.props.readOnly, onChange: this.handleQuestaoCorpoChange }));
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.confirmarExclusao !== this.state.confirmarExclusao 
            || !ErroQuestionarioQuestao.compare(nextProps.erros, this.props.erros)
            || !QuestionarioQuestao.compare(nextProps.questao, this.props.questao);
    }

    render() {
        const { questao, erros, classes, readOnly } = this.props;
        const { confirmarExclusao } = this.state;

        return (
            <VitalizePaper className={classes.questao} >
                <Grid container spacing={1} id="questao-container" >
                    <Grid container item xs={12} >
                        <Grid item xs >
                            <TextField 
                                name="titulo" 
                                label="Questão" 
                                type="text" 
                                placeholder="Título da questão" 
                                variant="outlined" 
                                size="small"
                                fullWidth 
                                required
                                autoFocus={this.props.focoAutomatico}
                                error={!!erros.titulo}
                                helperText={erros.titulo}
                                value={questao.titulo} 
                                onChange={this.handleChange} 
                            />        
                        </Grid>
                        {
                            !readOnly &&
                                <Grid item xs="auto" >
                                    <IconButton color="primary" id="mover-acima" size="small" onClick={this.handleUpClick} tabIndex={-1} >
                                        <ArrowUpwardIcon />
                                    </IconButton>
                                    <IconButton color="primary" id="mover-abaixo" size="small" onClick={this.handleDownClick} tabIndex={-1} >
                                        <ArrowDownwardIcon />
                                    </IconButton>
                                    <IconButton color="primary" id="excluir-questao" size="small" onClick={this.handleDeleteClick} tabIndex={-1} >
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>
                        }
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <FormControl fullWidth variant="outlined" size="small" error={!!erros.tipo} >
                            <InputLabel htmlFor="tipo">Tipo</InputLabel>
                            <Select 
                                id="tipo"
                                name="tipo" 
                                label="Tipo"
                                variant="outlined" 
                                fullWidth 
                                native 
                                required
                                value={questao.tipo} 
                                onChange={this.handleChange} 
                            >
                                <option></option>
                                {
                                    tipos.map(tipo => (
                                        <option key={tipo.id} value={tipo.id}>{tipo.descricao}</option>
                                    ))
                                }
                            </Select>
                            <FormHelperText id="tipo-helper">{erros.tipo}</FormHelperText>
                        </FormControl>
                    </Grid>
                    { this.renderizarCorpo(erros) }
                </Grid>
                <ConfirmDialog titulo="Deseja excluir essa questão?" open={confirmarExclusao} onClose={this.handleDialogClose} />
            </VitalizePaper>
        );
    }
}

Questao.propTypes = {
    /** Classes CSS */
    classes: PropTypes.shape({
        questao: PropTypes.string
    }),
    /** Objeto contendo os dados da questão */
    questao: PropTypes.instanceOf(QuestionarioQuestao).isRequired,
    /** Mensagens de erro da questão */
    erros: PropTypes.instanceOf(ErroQuestionarioQuestao),
    /** Indica se o componente terá o foco ao ser criado */
    focoAutomatico: PropTypes.bool,
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Evento disparado quando alguma informação da questão é alterada */
    onChange: PropTypes.func,
    /** Evento disparado quando o botão de exclusão é pressionado */
    onDelete: PropTypes.func,
    /** Evento disparado quando o botão de movimentação para cima é pressionado */
    onMoveUp: PropTypes.func,
    /** Evento disparado quando o botão de movimentação para baixo é pressionado */
    onMoveDown: PropTypes.func
};

Questao.defaultProps = {
    erros: new ErroQuestionarioQuestao(),
    readOnly: false
};

export default withStyles(styles)(Questao);